import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { StorageService } from './services/storage.service';
import { NomenclatureService } from './services/nomenclature.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

	title = 'LWR-NEW';

	constructor(private router: Router, private nomService: NomenclatureService, private authService: AuthService, private storageService: StorageService) { }

	ngOnInit(): void {
		// tuk se slaga ako im Ctrl+Shift+R
	}

	isUserLogged() {
		return this.authService.loggedIn();
	}

	get passwordMessage(): string | null {
		return this.storageService.getPasswordMessage();
	}

	dismissPasswordMessage() {
		this.storageService.removePasswordMessage(); // ако го пазиш в сториджа
	}
}
